module.exports = __webpack_public_path__ + "static/media/ntu-logo.ecd681d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/ntu-logo.png
// module id = 949
// module chunks = 0